import { AuthScreensGallery } from "@/features/auth/screens/AuthScreensGallery";
import { useNav } from "@/utils/nav";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/design/components/auth")({
    component: AuthScreensPage,
});

function AuthScreensPage() {
    useNav([
        { label: "Design", route: { to: "/design" } },
        { label: "Auth screens", route: { to: "/design/components/auth" } },
    ]);

    return <AuthScreensGallery />;
}
